export default {
  name: 'status',
  namespaced: true,
  state: {
    statusRefreshKey: 0,
    loading: false,
  },
  mutations: {
    refresh(state) {
      state.statusRefreshKey++
    },
    setLoading(state, flag) {
      state.loading = flag
    },
  },
}
